import React, {
  useState,
  useRef,
  useMemo,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import { defaultColParas, resetFilter, resetAllFilter, FilterChange } from "../../../functions/gbcs-functions";
import { BsX } from "../../../icons/bs";
import { Container, Button } from "react-bootstrap";

const GridMaster = forwardRef((props, ref) => {
  const [, setGridApi] = useState(null);
  const [filteredCol, setFilteredCol] = useState([]);
  const [, setRowData] = useState([]);
  const [, setData] = useState(props.rowDetails);
  const [searchReText, setSearchReText] = useState("");
  const gridRef = useRef();
  const fullrow = props.fullrow !== undefined ? props.fullrow : "";


  useEffect(() => {
    setData(props.rowDetails);
  }, [props.rowDetails]);

  let height =
    props.height === "" || props.height === undefined
      ? window.innerHeight - 120
      : props.height;

  let paginationPageSize =
    props.paginationPageSize === "" || props.paginationPageSize === undefined
      ? 6
      : props.paginationPageSize;

  if (filteredCol.length > 0) height = window.innerHeight - 200;

  const gridStyle = useMemo(() => ({ height: height, width: "100%" }), []);
  const gridStylewithFilter = useMemo(
    () => ({ height: window.innerHeight - 150, width: "100%" }),
    []
  );


  const defaultColDef = useMemo(() => {
    return defaultColParas();
  }, []);

  function onGridReady(params) {
    let temp = [];
    params.api.forEachNodeAfterFilter((node) => {
      temp.push(node.data);
    });
    setRowData(temp);
    if (props.setPropsgridAPI !== undefined) props.setPropsgridAPI(params.api);
    setGridApi(params.api);
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (typeof props.setExcelData === 'function') {
      props.setExcelData(temp);
    }
  }

  useEffect(() => {
    if (typeof props.setExcelData === 'function') {
      props.setExcelData(props.rowDetails);
    }
  }, [props.rowDetails]);

  useEffect(() => {
    let temp = [];
    setData(props.rowDetails);
    if (typeof props.setExcelData === 'function') {
      props.setExcelData(props.rowDetails);
    }
    if (gridRef.current.api) {
      gridRef.current.api.setQuickFilter(searchReText);
      gridRef.current.api.forEachNodeAfterFilter((node) => {
        temp.push(node.data);
      });
    }
    if (typeof props.setExcelData === 'function') {
      props.setExcelData(temp);
    }
    setData(temp);
  }, [gridRef.current, searchReText]);

  useImperativeHandle(ref, () => ({
    setSearch: async (text) => {
      setSearchReText(text);
    },
  }));

  return (
    <Container fluid className="grid-comp-container">
      {filteredCol.length > 0 && (
        <div className="d-flex" style={{ paddingBottom: "0.5%" }}>
          {filteredCol.map((item, index) => {
            return (
              <div key={item || `FilterCol${index}`} className="filter-col pr-0 me-2">
                <span className="ps-2 reset-filter-text">
                  {item}{" "}
                  <BsX size={18} onClick={() => resetFilter(gridRef, item, props.fieldNames)} />
                </span>
              </div>
            );
          })}
          <div>
            <Button className="clrbtn" onClick={() => { resetAllFilter(gridRef, props); }}>
              Clear All
            </Button>
          </div>
        </div>
      )}
      <div className="ag-theme-material d-none d-md-block d-lg-block"
        style={filteredCol.length <= 0 ? gridStyle : gridStylewithFilter}
      >
        <AgGridReact
          ref={gridRef}
          rowData={props.rowDetails}
          columnDefs={props.colDetails}
          defaultColDef={defaultColDef}
          defaultWelDef={props.defaultWolDef}
          weld={props.weldcol}
          onGridReady={onGridReady}
          pagination={props.pagination !== false}
          paginationPageSize={paginationPageSize}
          rowSelection={"multiple"}
          searchReText={props.searchReText}
          enableBrowserTooltips={true}
          onFilterChanged={(params) => {
            FilterChange(
              params,
              setFilteredCol,
              props.headerNames,
              setRowData,
              typeof props.setExcelData === 'function' ? props.setExcelData : () => { }
            );
          }}
          height={height}
          editType={fullrow}
          rowHeight={props.rowHeight}
          headerHeight={props.headerHeight}
          onCellValueChanged={props.onCellValueChanged}
        />
      </div>
    </Container>
  );
});

export default GridMaster;